.pagination-count{font-weight:500;font-size:.75rem;color:#68696f}
/*# sourceMappingURL=supplier-table-footer.component-RHISJ6HD.css.map */
